// 首页
import request from '@/utils/fetch'

// 验证token
export function verifyToken (type) {
  return request({
    url: '/homePage/verifyToken',
    method: 'get',
    params: {type: type}
  })
}
// 根据token查询菜单信息
export function getUserAndMenuByToken (type) {
  return request({
    url: '/homePage/getUserAndMenuByToken',
    method: 'get',
    params: {type: type}
  })
}

// 切换工作域
export function chageWorkArea (workArea) {
  return request({
    url: '/homePage/chageWorkArea',
    method: 'post',
    params: {workArea: workArea}
  })
}

// 首页-通知公告查询
export function getNewNotices () {
  return request({
    url: '/messageInfo/getNewNotices',
    method: 'get'
  })
}

// 首页-生日提醒
export function getNewBirthdayRemind () {
  return request({
    url: '/messageInfo/getNewBirthdayRemind',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/homePage/api_homePage.js